import { deleteRequestWithBody, getRequest } from '../../../core/utils/api';
import { type KeycloakContext } from '../keycloak/KeycloakProvider';
import type User from '../models/user';

export const getAllWhyellowAndAdminUsers = async (keycloak: KeycloakContext): Promise<User[] | undefined> => {
  const apiResponse = await getRequest<User[]>('user/admin-and-whyellow-users', keycloak);

  if (apiResponse.error) {
    return undefined;
  }
  return apiResponse.json;
};

export const deleteAdminById = async (userId: string, keycloak: KeycloakContext): Promise<boolean> => {
  const apiResponse = await deleteRequestWithBody('user/admin', keycloak, {
    UserId: userId,
  });
  return !apiResponse.error;
};

export const resendCredentialsByEmail = async (email: string, keycloak: KeycloakContext): Promise<boolean> => {
  const apiResponse = await getRequest(`user/credentials/${email}`, keycloak);

  if (apiResponse.error) {
    return false;
  }
  return true;
};
